import React from 'react';
import { Title } from 'shared';
import { Redemptions } from 'features/redemptions/components/Redemptions';

const RedemptionsPage: React.FC = () => {
  return (
    <>
      <Title title="Redemptions" />
      <Redemptions />
    </>
  );
};

export default RedemptionsPage;
